import ModelUtil from '@leverege/model-util';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
const TYPE = 'molten.thresholdizer.ParentAttribute';
const {
  tf
} = I18N.ns(TYPE);
function create(options) {
  const opts = options || {};
  return {
    type: TYPE,
    objectType: opts.objectType,
    attrName: null
  };
}
function thresholdFor(model, obj, context) {
  const parentRelationship = nearestItemParentRelationship(context.clientProps.relationship);
  let parentItem = parentRelationship?.objRef;
  parentItem = parentItem == null ? parentItem : DataSources.withData(parentItem);
  if (!parentItem) {
    return null;
  }
  const val = Attributes.get(model.attrName, parentItem.type, parentItem.data);
  return val?.unit ? val.value : val;
}
function nearestItemParentRelationship(relationship) {
  let parent = relationship?.parent;
  if (parent?.isItem) {
    return parent;
  }
  while (parent != null) {
    parent = parent.parent;
    if (parent?.isItem) {
      return parent;
    }
  }
  return null;
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('objectType'),
  ...ModelUtil.createAllValue('attrName'),
  thresholdFor,
  name: tf('parentAttribute', 'Parent Attribute'),
  nearestItemParentRelationship
};